import styled from 'styled-components';

// Renamed ItemContainer to StyledChecklistItemContainer for clarity
// Styles adapted from ProjectChecklistModal.styles.js TodoItem
export const StyledChecklistItemContainer = styled.div`
    display: flex;
    align-items: center; /* Changed from flex-start to center like TodoItem */
    gap: 8px;
    padding: 8px;
    background: ${props => props.isDragging ? 'rgba(255, 255, 255, 0.1)' : 'transparent'};
    border-radius: 4px; /* From TodoItem */
    transition: background 0.2s ease; /* From TodoItem */
    width: 100%; /* Kept from original ItemContainer */
    margin-bottom: 2px; /* From TodoList gap in ProjectChecklistModal.styles.js (gap: 2px;) */

    &:hover {
        background: rgba(255, 255, 255, 0.05); /* From TodoItem */
    }
`;

// Styles from ProjectChecklistModal.styles.js Checkbox
export const Checkbox = styled.input`
    margin: 0;
    width: 18px;
    height: 18px;
    border-radius: 2px;
    cursor: pointer;
    appearance: none;
    border: 2px solid rgba(255, 255, 255, 0.5);
    background: transparent;
    position: relative;
    flex-shrink: 0; /* Prevent shrinking */

    &:checked {
        background: #0079BF; /* From ProjectChecklistModal */
        border-color: #0079BF; /* From ProjectChecklistModal */

        &:after {
            content: '✓';
            position: absolute;
            color: white;
            font-size: 12px;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    &:disabled { /* From ProjectChecklistModal, though not directly used by ChecklistItem, good to have */
        opacity: 0.5;
        cursor: default;
    }
`;

// Renamed ItemTitle to StyledTextarea
// Styles from ProjectChecklistModal.styles.js TodoInput
export const StyledTextarea = styled.textarea`
    height: 24px; /* Default height, will auto-adjust */
    flex: 1;
    background: transparent;
    border: none;
    color: ${props => props.checked ? 'rgba(255, 255, 255, 0.5)' : '#fff'};
    font-size: 14px;
    padding: 4px;
    text-decoration: ${props => props.checked ? 'line-through' : 'none'};
    resize: none;
    overflow-y: hidden; /* Crucial for auto-height adjustment with scrollHeight */
    white-space: pre-wrap; /* To respect newlines and wrap text */
    font-family: inherit; /* Keep original font */
    line-height: 1.5; /* Keep original line-height */

    &::placeholder {
        color: rgba(255, 255, 255, 0.5); /* From ProjectChecklistModal */
    }

    &:focus {
        outline: none;
        /* border-radius: 3px; */ /* Removed to match ProjectChecklistModal more closely */
    }
`;

// Styles from ProjectChecklistModal.styles.js DeleteButton
export const DeleteButton = styled.button`
    background: none;
    border: none;
    color: rgba(255, 255, 255, 0.5);
    font-size: 18px; /* From ProjectChecklistModal */
    cursor: pointer;
    padding: 0 4px; /* From ProjectChecklistModal */
    opacity: 0; /* From ProjectChecklistModal */
    transition: opacity 0.2s ease; /* From ProjectChecklistModal */
    display: flex; /* Added to align icon if needed */
    align-items: center; /* Added to align icon if needed */
    justify-content: center; /* Added to align icon if needed */
    width: 24px; /* Keep original width */
    height: 24px; /* Keep original height */
    flex-shrink: 0; /* Prevent shrinking */


    ${StyledChecklistItemContainer}:hover & {
        opacity: 1; /* From ProjectChecklistModal */
    }

    &:hover {
        color: #FF5F5F; /* From ProjectChecklistModal */
        background: transparent; /* Ensure no background on hover from original */
    }
`;

// DragHandle styles are kept similar, but the icon itself will be SVG in the component
// The ProjectChecklistModal uses an inline SVG with a div wrapper for dragHandleProps
// This styled component might still be useful for the wrapper div
export const DragHandle = styled.div`
  /* color: #8C9BAB; Original color, ProjectChecklistModal uses #fff for SVG fill */
  cursor: grab;
  padding: 4px; /* Adjust padding as needed */
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px; /* Match size of icon/button */
  height: 24px; /* Match size of icon/button */
  flex-shrink: 0; /* Prevent shrinking */

  svg {
    fill: rgba(255, 255, 255, 0.7); /* Default color for SVG */
  }

  ${StyledChecklistItemContainer}:hover & svg {
    fill: #fff; /* Brighter on hover of item */
  }

  &:active {
    cursor: grabbing;
  }
`;

// ConvertToCardButton styles are preserved but adapted for new container
export const ConvertToCardButton = styled.button`
  opacity: 0;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.7); /* Adjusted for consistency */
  padding: 4px;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  transition: all 0.2s ease;
  min-width: 28px; /* Original */
  height: 24px; /* Adjusted to match textarea default height and other icons */
  justify-content: center;
  flex-shrink: 0;
  /* margin: auto; Removed, will be aligned by flex gap */

  &:hover {
    background: rgba(255, 255, 255, 0.1); /* Subtle hover */
    color: #fff; /* Brighter on hover */
  }

  ${StyledChecklistItemContainer}:hover & {
    opacity: 1;
  }
`;
